import { render, staticRenderFns } from "./StockClosingDetail_Items.vue?vue&type=template&id=f97e6ef6&"
import script from "./StockClosingDetail_Items.vue?vue&type=script&lang=js&"
export * from "./StockClosingDetail_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports